import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PostSuccess.css';

const PostSuccess = () => {
  const navigate = useNavigate();

  const handleViewPost = () => {
    navigate('/grid');
  };

  const handleHome = () => {
    navigate('/HomeScreen');
  };

  const postedOn = new Date().toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="psuccess-page">
      <main className="psuccess-ticket">
        <div className="psuccess-ticket-top">
          <span className="psuccess-stamp" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="26" height="26">
              <path
                d="M4 12.5L9.5 18L20 6.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          <h1 className="psuccess-heading">
            Your idea is out in the world.
          </h1>

          <p className="psuccess-message">
            Somewhere out there, someone needed to read exactly this.
            Thanks for putting your thinking out there — the board is a
            little richer for it.
          </p>

          <p className="psuccess-timestamp">Posted on {postedOn}</p>
        </div>

        <div className="psuccess-perforation" aria-hidden="true"></div>

        <div className="psuccess-ticket-bottom">
          <button className="psuccess-primary-btn" onClick={handleViewPost}>
            View your post
          </button>
          <button className="psuccess-secondary-btn" onClick={handleHome}>
            Go to home
          </button>
        </div>
      </main>
    </div>
  );
};

export default PostSuccess;